module.exports = __webpack_public_path__ + "static/media/life_skills3efd42cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/life_skills.svg
// module id = 1333
// module chunks = 0